import { Theme, makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import React from 'react'

interface ICardProps {
  children: React.ReactNode
  className?: string
  displayLogo?: boolean
  rootClassName?: string
}

function Card(props: ICardProps) {
  const classes = useStyles()

  return (
    <div className={classNames(classes.root, props.rootClassName)}>
      <div className={classNames(classes.container, props.className)}>{props.children}</div>
    </div>
  )
}

export { default as CardMenuContainer } from './CardMenuContainer'
export { default as CardTabHeader } from './CardTabHeader'
export { default as CardSection } from './CardSection'
export { default as CardFooter } from './CardFooter'
export { default as CardHeader } from './CardHeader'
export default Card

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flex: 1,
    minHeight: '100%',
    minWidth: 500,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderTopRightRadius: 'inherit',
    borderBottomRightRadius: 'inherit',
    boxShadow: 'none',
  },
  container: {
    flex: 1,
    background: theme.palette.common.white || 'white',
    borderRadius: 'inherit',
    boxShadow: 'none',
  },
}))
